<template>
  <div class="input-container">
    <label :class="{ labelObrigatorio: (required && campoVazio) || isDataInvalida }"> {{ label }}</label>
    <input
      class="input"
      :class="{ 'data-invalida': isDataInvalida || (required && campoVazio) }"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :id="id"
      :isDiaMesEAno="isDiaMesEAno"
      :isAno="isAno"
      isMesEAno="isMesEAno"
      :value="modelValue"
      @input="this.$emit('update:modelValue', adicionarMascara($event))"
      @blur="validarData"
      @keyup="$event=>verificarSeInputEstaVazio($event,false)"
      :required="required"
      :disabled="disabled"
      :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
    />
    <div class="mensagemDeErro">
      <span v-if="required && campoVazio && mensagemCampoObrigatorio" class="campo-obrigatório">
        {{ mensagemCampoObrigatorio }}
      </span>

      <span v-else-if="required && campoVazio && label != null" class="campo-obrigatório"
        >{{ label }} é obrigatório.</span
      >
      <span v-else-if="required && campoVazio" class="campo-obrigatório">Campo obrigatório.</span>

      <span v-if="isDataInvalida" class="campo-obrigatório"
        >{{ mensagemDataInvalida? mensagemDataInvalida : "Formato de data inválido." }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfDateInput",
  props: {
    placeholder: String,
    id: String,
    label: String,
    maxlength: String,
    modelValue: String,
    isMesEAno: Boolean,
    isAno: Boolean,
    isDiaMesEAno: Boolean,
    required: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    permitirAnterior: {
      type: Boolean,
      default: true
    },
    mensagemCampoObrigatorio: String
  },
  data() {
    return {
      isDataInvalida: false,
      dia: "",
      mes: "",
      ano: "",
      campoVazio: false,
      mensagemDataInvalida: "Formato de data inválido."
    };
  },
  methods: {
    verificarSeInputEstaVazio(event,deveOcultarMensagemDeErro) {
      if (event?.key == 'Tab') {
        return;
      }
      
      if (deveOcultarMensagemDeErro || this.modelValue !== "") {
        return (this.campoVazio = false);
      } else {
        return (this.campoVazio = true);
      }
    },

    adicionarMascara(e) {
      let data = e.target.value;
      if(this.isAno) return data;
      data = data.replace(/\D/g, "");

      if(this.isDiaMesEAno) {
        data = data.replace(/^(\d{2})(\d{2})(\d)/, "$1/$2/$3");
      } else {
        data = data.replace(/^(\d{2})(\d)/, "$1/$2");
      }
      
      return (e.target.value = data);
    },

    validarData(e) {
      let data = e.target.value;

      this.validarQualTipoDeDataFoiInserido(data);

      if (!data) {
        return;
      } else if (
        !this.validarSeDataInseridaNaoFoiAlteradaPosConversao(this.dia, this.mes, this.ano)
      ) {
        this.$emit("update:modelValue", "");
        this.isDataInvalida = true;
        this.mensagemDataInvalida = "Formato de data inválido."
      } else if (!this.permitirAnterior && this.isDataAnterior(this.dia, this.mes, this.ano)) {
        this.$emit("update:modelValue", "");
        this.isDataInvalida = true;
        this.mensagemDataInvalida = "A data inserida deve ser maior ou igual à data atual."
      }else {
        this.isDataInvalida = false;
        this.mensagemDataInvalida = ""
      }
      return this.isDataInvalida
    },

    isDataAnterior(dia, mes, ano) {
      const dataFormatada = ano + "/" + mes + "/" + dia;
      const date = new Date(dataFormatada);
      const hoje = new Date();
      
      hoje.setHours(0, 0, 0, 0)

      return date < hoje
    },

    validarSeDataInseridaNaoFoiAlteradaPosConversao(dia, mes, ano) {
      const dataFormatada = ano + "/" + mes + "/" + dia;
      let d = new Date(dataFormatada);
      return dia == d.getDate() && mes - 1 == d.getMonth() && ano == d.getFullYear();
    },

    limparValidacao() {
      this.campoVazio = false;
      this.isDataInvalida = false;
    },
    
    limparInput() {
      this.modelValue == ''
    },

    validarQualTipoDeDataFoiInserido(data) {
      const anoAtual = new Date().getFullYear();

      const dataArray = data.split("/");

      if (this.isMesEAno) {
        this.dia = parseInt(dataArray[0]);
        this.mes = parseInt(dataArray[1]);
        this.ano = anoAtual;
        return this.dia, this.mes, this.ano;
      } else if(this.isDiaMesEAno) {
        this.dia = parseInt(dataArray[0]);
        this.mes = parseInt(dataArray[1]);
        this.ano = parseInt(dataArray[2]);
        return this.dia, this.mes, this.ano;
      } else if (!!this.isAno) {
        this.dia = 1;
        this.mes = 1;
        this.ano = parseInt(dataArray[0]);
      } else {
        this.dia = 1;
        this.mes = parseInt(dataArray[0]);
        this.ano = parseInt(dataArray[1]);
        return this.dia, this.mes, this.ano;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

.data-invalida {
  border-color: #a94442;
}

.data-invalida:hover {
  border-color: #a94442;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}

input[disabled] {
  border-color:var(--ms-border-color, #cccccc);
}
.labelObrigatorio {
  color: #a94442;
}
</style>
